import { orderString } from './functions'
import React from 'react'
import { Divider } from 'antd'
import store from '../config/redux-store'
import { removeUser, goToEditUser } from '../App/containers/admin/admin.actions';
import showConfirm from '../App/components/confirmModal/confirmModal';


export default [
    {
        title: 'Nome',
        dataIndex: 'name',
        key: `name`,
        sorter: (a, b) => orderString(a.name, b.name),
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: `email`,
        sorter: (a, b) => orderString(a.email, b.email),
    },
    {
        title: 'Login',
        dataIndex: 'username',
        key: `username`,
        sorter: (a, b) => orderString(a.username, b.username),
    }, {
        title: "",
        key: "action",
        render: ({text, record, x}) => (
            <span>
                <a href="javascript:;" onClick={() => x()} className='btn-edit'>Editar</a>
                <Divider type="vertical" />
                <a href="javascript:;" onClick={() => showConfirm(`Tem certeza que deseja remover" ${text.name} "`, "", () => store.dispatch(removeUser(text.id)))}  className='btn-delete'>Delete</a>
            </span >
        )

    }

];



// WEBPACK FOOTER //
// ./src/utils/table-admins-columns.js